import React, { useEffect, useState } from "react";
import CustomDialog from "../../../components/layouts/common/CustomDialog";
import { callApiAction } from "../../../store/actions/commonAction";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import loadingImg from "../../../assets/images/loading.gif";
import { getPatientByIdApi } from "../../../apis/patient.api";
import PatientInformation from "./PatientInformation";

const PatientInformationController = ({ id }) => {
  const [params, setParams] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const fetchDetails = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getPatientByIdApi({ id }),
        (response) => {
          setParams(response);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  };

  useEffect(() => {
    if (id) {
      fetchDetails();
    }
  }, [id]);

  return (
    <CustomDialog id={"PatientInformation"} title={`Patient Information`}>
      {!loading ? (
        <>
          <PatientInformation
            params={params}
            // data={data}
          />
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={loadingImg} alt="Loading ..." />
        </Box>
      )}
    </CustomDialog>
  );
};

export default PatientInformationController;
